import {
  getProductInformationByBrandSlug,
  PRODUCT_INFORMATION_LIST,
} from "../productInformation/productInformationData";

export interface TcgRouteItem {
  brand: string;
  slug: string;
  /** Same as slug — product lookup key in the campaign catalog. */
  productSlug: string;
}

/** Derived from full campaign catalog (includes archived / non-banner entries). */
export const TCG_ROUTE_ITEMS: TcgRouteItem[] = PRODUCT_INFORMATION_LIST.map(
  (entry) => ({
    brand: entry.brand,
    slug: entry.slug,
    productSlug: entry.slug,
  }),
);

export function getTcgRouteItem(
  brand?: string,
  slug?: string,
): TcgRouteItem | null {
  const entry = getProductInformationByBrandSlug(brand, slug);
  if (!entry) return null;
  return {
    brand: entry.brand,
    slug: entry.slug,
    productSlug: entry.slug,
  };
}
